var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCirclePlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 17335",
    d: "M20.909 15.426l-6.633-4.543c-.745-.51-2.02-.149-2.02.574v9.089c0 .722 1.275 1.084 2.02.573l6.633-4.544a.648.648 0 000-1.147"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 17336",
    d: "M16 32a16 16 0 1116-16 16.019 16.019 0 01-16 16m0-29a13 13 0 1013 13A13.015 13.015 0 0016 3"
  }))));
}
export default SvgCirclePlay;